export function isAiReportAssistantEnabled() {
  return (
    String(process.env.REACT_APP_ENABLE_AI_REPORT_ASSISTANT || '')
      .toLowerCase()
      .trim() === 'true'
  )
}

export const AI_REPORT_UNMAPPABLE_MESSAGE =
  "I couldn't safely map that request to available report columns. Try asking for order, customer, event, payment, revenue, or Stripe validation fields."
